

export class ShiftAttendanceRequest {
    fromDate: string;
    toDate: string;
    shift?: string;
    employeeId?:number;

    /**
     * 
     * @param fromDate 
     * @param toDate 
     * @param shift 
     */
    constructor(fromDate: string, toDate: string, shift?: string,employeeId?:number) {
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.shift = shift;
        this.employeeId = employeeId
    }
}